<div class="headerFlexW pr-4 m-3">
    <div class="content-block">
        <p class="bread-crumbs"> Tercerización de pagos / Nueva solicitud</p>
        <h2 class="">Tercerización de pagos</h2>
    </div>
</div>

<div class="dx-card content-block pt-3">
    <!-- TOP CONTAINER  -->
    <div class="responsive-paddings">
        <h3>Datos de la solicitud</h3>
        <div class="flex flex-nowrap round-border-2">
            <!-- Left  -->
            <div class="flex-grow-1 mr-4">
                <!-- <div class='dx-field'>
                    <div class='dx-field-label'>Departamento</div>
                    <div class='dx-field-value'>
                        <dx-select-box [dataSource]="cmgCategories" displayExpr="name" valueExpr="id"
                            [(value)]="cmgCategory" isRequired="true"
                            (onValueChanged)="onChangeCategory($event.value)">
                            <dx-validator>
                                <dxi-validation-rule type='required' message='Requerido'></dxi-validation-rule>
                            </dx-validator>
                        </dx-select-box>

                    </div>
                </div> -->
                <!-- <div class='dx-field'>
                    <div class='dx-field-label'>Categoria</div>
                    <div class='dx-field-value'>
                        <dx-select-box [dataSource]="cmgSubCategories" displayExpr="name" valueExpr="id"
                            [(value)]="cmgSubCategory" isRequired="true"
                            (onValueChanged)="onChangeSubCategory($event.value)">
                            <dx-validator>
                                <dxi-validation-rule type='required' message='Requerido'></dxi-validation-rule>
                            </dx-validator>
                        </dx-select-box>

                    </div>
                </div> -->
                <div class="dx-field">
                    <div class="dx-field-label">Proveedor / Beneficiario</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]="paymentRequest.nameBeneficiary">
                            <dx-validator>
                                <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
                <div class='dx-field mb-0'>
                    <div class='dx-field-label'>Beneficiario</div>
                    <div class='dx-field-value'>
                        <dx-select-box [dataSource]="beneficiariesCatalog" displayExpr="beneficiaryComercialName"
                            valueExpr="id" [(value)]="paymentRequest.beneficiary.id" (onValueChanged)="checkCompany($event.value)"
                            [searchEnabled]="true"
                            searchExprOption="beneficiaryComercialName"
                            searchMode="contains">
                            <!-- <dx-validator>
                                <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                            </dx-validator> -->
                        </dx-select-box>
                    </div>
                </div>
                <div class='dx-field mt-0 mb-3'>
                    <div class='dx-field-label'>
                        <a [routerLink]="" (click)="createNewBeneficiary()">Nuevo Beneficiario</a>
                    </div>
                    <div class='dx-field-value txt-right'></div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Código CMG</div>
                    <div class='dx-field-value'>
                        <dx-select-box [searchEnabled]="true" [dataSource]="cmgCatalog" displayExpr="cmg" valueExpr="cmg"
                            [(value)]="paymentRequestCMG" isRequired="true"
                            (onValueChanged)="getCmgData($event.value)"
                            [searchEnabled]="true"
                            searchExprOption="cmg"
                            searchMode="contains">
                            <dx-validator>
                                <dxi-validation-rule type='required' message='Requerido'></dxi-validation-rule>
                            </dx-validator>
                        </dx-select-box>

                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label">Concepto de pago</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]="paymentRequest.concept">
                            <dx-validator>
                                <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label">Pedido</div>
                    <div class='dx-field-value'>
                        <dx-number-box [showSpinButtons]="false" format="###0##" [(value)]="paymentRequest.order"
                            [min]="0">
                            <dx-validator>
                                <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                            </dx-validator>
                        </dx-number-box>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label">Entrada</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]="paymentRequest.entry">
                            <dx-validator>
                                <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
                <div class="dx-field" *ngIf="facturaSuperlativeVisible">
                    <div class="dx-field-label">Factura Superlative</div>
                    <div class='dx-field-value'>
                        <dx-number-box format="###0##" [(value)]="paymentRequest.facturaSuperlative">
                        </dx-number-box>
                    </div>
                </div>
                
                
            </div>
            <!-- Right  -->
            <div class="flex-grow-1 ml-4">
                <div class='dx-field'>
                    <div class='dx-field-label'>Razón Social que solicita</div>
                    <div class='dx-field-value'>
                        <dx-select-box [dataSource]="requestSocial" displayExpr="name" valueExpr="name"
                            [(value)]="paymentRequest.requestSocial" isRequired="true"
                            (onValueChanged)="getRequestSocilData($event.value)" 
                            [searchEnabled]="true"
                            searchExprOption="name"
                            searchMode="contains"
                            >
                            <dx-validator>
                                <dxi-validation-rule type='required' message='Requerido'></dxi-validation-rule>
                            </dx-validator>
                        </dx-select-box>

                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label">Pago sin IVA Proveedor / Beneficiario</div>
                    <div class='dx-field-value'>
                        <dx-number-box [showSpinButtons]="false" format="$ #,##0.##" [(value)]="paymentRequest.amount"
                        [min]="0" (onValueChanged)="calculateFees($event.value)">
                        <dx-validator>
                            <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                        </dx-validator>
                    </dx-number-box>
                </div>
            </div>
            <div class="dx-field">
                <div class="dx-field mb-0 ">
                    <div class="dx-field-label">Aplica IVA</div>
                    <div class="dx-field-value">
                        <dx-switch [(value)]="isIva" (onValueChanged)="onValueChangedApp($event.value,paymentRequest.amount)"></dx-switch>
                    </div>
                </div>
            </div>
            <div class="dx-field">
                <div class="dx-field-label">Pago sin IVA Superlative</div>
                <div class='dx-field-value'>
                    <dx-number-box [showSpinButtons]="false" format="$ #,##0.##" [(value)]="paymentRequest.paymentWithoutIva"
                        [min]="0">
                        <dx-validator>
                            <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                        </dx-validator>
                    </dx-number-box>
                </div>
            </div>
            <div class="dx-field">
                    <div class="dx-field-label">Notas</div>
                    <div class='dx-field-value'>
                        <dx-text-area [(value)]="paymentRequest.notes">
                        </dx-text-area>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label">Cargar comprobantes</div>
                    <div class='dx-field-value'>
                        <label class="image-upload-container btn btn-bwm">
                            <i class="dx-icon-file"></i>
                            <span>Seleccionar archivo</span>
                            <input #imageInput
                                   type="file"
                                   accept="image/*,.doc,.docx,.pdf"
                                   (change)="processFile(imageInput)">
                        <div *ngIf="response_upload === 4">
                          <div class=""><i class="far fa-check status-2 status-ico"></i>Carga completa</div>
                        </div>
                        <div *ngIf="response_upload === 5">
                          <div class=""><i class="fas fa-times status-4 status-ico"></i>No se cargó el archivo</div>
                        </div>
                        </label>
                    </div>
                </div> 
                <div class="progress form-group" *ngIf="progress > 0">
                    <div class="progress-bar progress-bar-striped bg-success" role="progressbar" [style.width.%]="progress"></div>
                </div>
                <div  class="dx-field">
                    <ul>
                        <li *ngFor="let product of files_preload">
                            <h3><a href="{{product.url}}">{{product.fileName}}</a></h3>
                        </li>
                      </ul>
                </div>
            </div>
        </div>
    </div>

    <!-- BOTTOM CONTAINER  -->
    <div class="responsive-paddings">
        <h3>Detalles</h3>
        <div class="flex flex-nowrap round-border-2">
            <!-- Left  -->
            <div class=" flex-grow-1 mr-4">
                <h4>Detalles del Beneficiario</h4>
                <ul>
                    <li>Persona: <span *ngIf="paymentRequest.beneficiaryIsInc">Física</span> <span
                            *ngIf="!paymentRequest.beneficiaryIsInc">Moral</span></li>
                    <!-- <li>Nombre comercial: {{paymentRequest.beneficiary.beneficiaryLegalName}}</li> -->
                    <li>Nombre Comercial: {{paymentRequest.beneficiary.beneficiaryComercialName}}</li>
                    <li *ngIf="paymentRequest.beneficiaryIsInc">Razón social:
                        {{paymentRequest.beneficiary.beneficiaryLegalName}}</li>
                    <li *ngIf="!paymentRequest.beneficiaryIsInc">Nombre:
                        {{paymentRequest.beneficiary.beneficiaryFirstName}}
                        {{paymentRequest.beneficiary.beneficiarySecondName}}
                        {{paymentRequest.beneficiary.beneficiaryLastName}}
                        {{paymentRequest.beneficiary.beneficiarySecondLastName}}</li>
                    <li class="uper-case">RFC: {{paymentRequest.beneficiary.rfc}}</li>
                    <li>Banco: {{paymentRequest.beneficiary.bank}}</li>
                    <li>CLABE: {{paymentRequest.beneficiary.clabe}}</li>
                    <li>Cuenta: {{paymentRequest.beneficiary.accountNumber}}</li>
                    <li>Dirección: {{paymentRequest.beneficiary.adress}}</li>
                    <li>Ciudad: {{paymentRequest.beneficiary.city}}</li>
                    <li>Estado: {{paymentRequest.beneficiary.state}}</li>
                    <li>CP: {{paymentRequest.beneficiary.zip}}</li>
                </ul>
                
            </div>
            <!-- Right  -->
            <div class="flex-grow-1 ml-4">
                <h4>Detalles del pago</h4>
                <ul>
                    <li>Concepto: {{paymentRequest.concept}}</li>
                    <li>Pedido: {{paymentRequest.order}}</li>
                    <li>Entrada: {{paymentRequest.entry}}</li>
                    <li>Cantidad: {{paymentRequest.amount | currency}}</li>
                    <li>IVA: {{paymentRequest.tax | currency}}</li>
                    <li>Comisión: {{paymentRequest.fee | currency}}</li>
                    <li>TOTAL: {{paymentRequest.total | currency}}</li>
                </ul>
                <ul>
                    <li>Código CMG: {{paymentRequest.cmg.cmg}}</li>
                    <li>Desc: {{paymentRequest.cmg.desc}}</li>
                    <li>Lider: {{leaderName}}</li>
                    <li>Departamento: {{paymentRequest.cmg.level1}} - {{paymentRequest.cmg.level1Cat}}</li>
                    <li>Categoria: {{paymentRequest.cmg.level2}} - {{paymentRequest.cmg.level2Cat}}</li>
                    <!-- <li>Cat 3: {{paymentRequest.cmg.level3}} - {{paymentRequest.cmg.level3Cat}}</li> -->
                </ul>
                <div class="float-right">
                    <dx-button id="button" [useSubmitBehavior]="true" type="default"
                        (onClick)="onFormUpdateSubmit($event)" text="Enviar Solicitud">
                    </dx-button>
                </div>
            </div>
        </div>
    </div>
</div>